import moment from 'moment';
import * as React from "react";
import { callApi } from "../../utils/api";
import { isEmpty } from "lodash";
import { ToastsStore } from 'react-toasts';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

interface AllProps {
    id: number;
    match: any;
    history: any
}

export default class VerifyHintAboutFile extends React.Component<AllProps> {
    state = {
        hints: [],
        userHintAboutFile: ''
    };
    file_id: any;

    componentDidMount() {
        this.getHints();
    }

    getHints = () => {
        callApi("POST", "hint_get.php", { id: this.props.match.params.id })
            .then(res => res.data)
            .then(result => {
                this.setState({ hints: result.data })
            })
            .catch(err => {
                console.log(err);
            });
    }

    handleEditorChange = (content: string) => {
        const cleaned = content
            // Remove all inline style attributes
            .replace(/\s*style="[^"]*"/gi, "")
            // Remove all inline style with single quotes
            .replace(/\s*style='[^']*'/gi, "")
            // Remove box-sizing and other junk attributes
            .replace(/\s*(class|id|data-[^=]*)="[^"]*"/gi, "")
            // Collapse multiple <br> tags
            .replace(/(<br\s*\/?>){2,}/gi, "<br>")
            // Remove leading empty paragraphs (including those with <br> that might not be properly closed)
            .replace(/^(<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>)*/gi, "")
            .replace(/^(<p>(\s|&nbsp;|<br\s*\/?>)*)/gi, "") // Also catch opening <p> without closing tag
            // Remove trailing empty paragraphs
            .replace(/(<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>)*$/gi, "")
            .replace(/(<br\s*\/?>)*<\/p>$/gi, "</p>") // Clean up trailing <br> before closing </p>
            // Remove empty spans
            .replace(/<span[^>]*>\s*<\/span>/gi, "")
            // Remove zero-width spaces
            .replace(/​/g, "")
            .trim();

        this.setState({ userHintAboutFile: cleaned });
    }

    saveHint = () => {
        // Strip all HTML tags and decode &nbsp; to check actual text content
        const plainText = this.state.userHintAboutFile
            .replace(/<[^>]*>/g, "")       // strip HTML tags
            .replace(/&nbsp;/g, " ")        // decode &nbsp;
            .replace(/​/g, "")       // remove zero-width spaces
            .replace(/\u200B/g, "")         // remove zero-width space (unicode)
            .trim();

        if (isEmpty(plainText) || /^[\s-]/.test(plainText)) {
            ToastsStore.error("Hint cannot be empty");
            return;
        }

        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";

        callApi('POST', 'add_hints.php', {
            id: this.props.match.params.id,
            userid: userId,
            hints: this.state.userHintAboutFile
        })
            .then(res => res.data)
            .then(result => {
                this.setState({ userHintAboutFile: '' });
                ToastsStore.success("Hint added successfully");
                this.getHints();
            })
            .catch(err => {
                console.log(err);
            });
    }

    previousPage() {
        this.props.history.goBack()
    }

    render() {
        return (
            <section className="pcoded-main-container">
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="card latest-update-card">
                                        <div className="card-header row">
                                            <div className="col-md-11">
                                                <h5>Hints About Files</h5>
                                            </div>
                                            <div className="col-md-1">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline"
                                                    onClick={() => this.previousPage()}
                                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                                > Back</button>
                                            </div>
                                        </div>

                                        <div className="" style={{ height: '320px', position: 'relative', overflow: 'auto' }}>
                                            <div className="card-body">
                                                <div className="latest-update-box">
                                                    {this.state.hints && this.state.hints.length > 0 && this.state.hints.map((hint: any, index: number) => (
                                                        <div className={index === 0 ? "row p-t-20 p-b-20" : "row p-b-20"} key={index}>
                                                            <div className="col-auto text-right update-meta">
                                                                <i className="b-primary update-icon ring"></i>
                                                            </div>
                                                            <div className="col p-l-5">
                                                                <h6 className="m-0">{hint.created_by}  <span style={{ fontSize: '12px' }}>{hint.created_date ? "(" + moment(hint.created_date).format('DD/MM/YYYY hh:mm:ss') + ")" : ''}</span></h6>
                                                                <p className="m-b-0" style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: hint.hints }} />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="ps__rail-x" style={{ left: '0px', bottom: '0px' }}>
                                                <div className="ps__thumb-x" style={{ left: '0px', bottom: '0px' }}></div>
                                            </div>
                                            <div className="ps__rail-y" style={{ top: '0px', height: '320px', right: '0px' }}>
                                                <div className="ps__thumb-y" style={{ top: '0px', height: '212px' }}></div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Add Hints</label>
                                                <SunEditor
                                                    setContents={this.state.userHintAboutFile}
                                                    onChange={this.handleEditorChange}
                                                    onPaste={(e, cleanData, maxCharCount) => {
                                                        // Let handleEditorChange handle the cleanup via onChange
                                                        return true;
                                                    }}
                                                    onKeyDown={(e) => {
                                                        // Prevent any formatting shortcuts except Ctrl+B
                                                        if ((e.ctrlKey || e.metaKey)) {
                                                            const key = e.key.toLowerCase();
                                                            // Allow only basic editing shortcuts
                                                            const allowedKeys = ['b', 'x', 'c', 'v', 'a', 'z', 'y'];
                                                            if (!allowedKeys.includes(key)) {
                                                                e.preventDefault();
                                                                return false;
                                                            }
                                                        }
                                                        return true;
                                                    }}
                                                    setOptions={{
                                                        height: '25vh',
                                                        defaultStyle: 'line-height: 1.15; font-size: 12px;',
                                                        pasteTagsWhitelist: 'p|br|strong|em|u|s|ul|ol|li', // only allow clean tags on paste
                                                        buttonList: [
                                                            ['bold'],
                                                        ],
                                                    }}
                                                />
                                            </div>
                                            <button onClick={this.saveHint} className="btn btn-rounded btn-success">
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}